import { render } from "./Carousel.vue?vue&type=template&id=74b1967c&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=74b1967c&class=carousel&scoped=true&lang=css"

import exportComponent from "C:\\Users\\clha\\Documents\\Development\\interflon-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b1967c"]])

export default __exports__